(() => {
  if (customElements.get('bek-custom-size')) return;
  // 2026-09-16 (Claude): mehrere Maßfelder möglich (CORNER: zwei Seitenlängen).
  class CustomSize extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggle = this.previousElementSibling?.querySelector('[data-custom-size-toggle]');
      this.form = this.querySelector('form');
      this.fields = Array.from(this.querySelectorAll('[data-custom-size-width]'));
      this.next = this.querySelector('[data-custom-size-next]');
      this.emailStep = this.querySelector('[data-custom-size-email-step]');
      this.email = this.querySelector('[data-custom-size-email]');
      this.section = this.closest('.product-section');
      this.guard = event => {
        if (this.hidden) return;
        const purchase = event.target.closest('form[action*="/cart/add"], [data-add-to-cart], [data-bek-satc-button], .shopify-payment-button');
        if (!purchase) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.firstInvalid()?.focus();
      };
      this.section?.addEventListener('click', this.guard, true);
      this.section?.addEventListener('submit', this.guard, true);
      this.toggle?.addEventListener('click', () => this.open(this.hidden));
      if (this.querySelector('[data-custom-size-result], [data-custom-size-error]')) this.open(true);
      if (!this.fields.length || !this.form) return;
      this.fields.forEach(field => field.addEventListener('input', () => {
        this.next.hidden = !this.validSize() || !this.emailStep.hidden;
      }));
      this.next.addEventListener('click', () => this.advance());
      this.form.addEventListener('submit', event => {
        if (this.emailStep.hidden) {
          event.preventDefault();
          this.advance();
        } else if (!this.validSize()) {
          event.preventDefault();
          this.firstInvalid()?.reportValidity();
        }
      });
    }
    validField(field) {
      return field.value !== '' && Number.isFinite(field.valueAsNumber) && field.checkValidity();
    }
    validSize() {
      return this.fields.every(field => this.validField(field));
    }
    firstInvalid() {
      return this.fields.find(field => !this.validField(field)) || this.fields[0];
    }
    open(show) {
      this.hidden = !show;
      this.toggle?.setAttribute('aria-expanded', String(show));
      this.section?.classList.toggle('bek-custom-size-active', show);
      this.section?.querySelectorAll('form[action*="/cart/add"], [data-bek-satc]').forEach(element => {
        if (show && !element.hasAttribute('inert')) {
          element.setAttribute('data-custom-size-inert', '');
          element.inert = true;
        } else if (!show && element.hasAttribute('data-custom-size-inert')) {
          element.inert = false;
          element.removeAttribute('data-custom-size-inert');
        }
      });
      if (show) (this.querySelector('[data-custom-size-result]') || this.fields[0])?.focus();
    }
    advance() {
      if (!this.validSize()) { this.firstInvalid()?.reportValidity(); return; }
      this.emailStep.hidden = false;
      this.email.disabled = false;
      this.next.hidden = true;
      this.email.focus();
    }
    disconnectedCallback() {
      this.open(false);
      this.section?.removeEventListener('click', this.guard, true);
      this.section?.removeEventListener('submit', this.guard, true);
    }
  }
  customElements.define('bek-custom-size', CustomSize);
})();
